const Years = () => {
  const getCurrentYear = new Date().getFullYear();
  let data = [];
  for (let i = 2010; i <= getCurrentYear; i++) {
    data.push({ value: i, label: i });
  }
  return data;
};
export default Years;


// WEBPACK FOOTER //
// ./src/components/Helpers/Lists/Years.js